export default __webpack_public_path__ + "static/media/insta.25217b99.svg";